import { render, staticRenderFns } from "./add-merchants.vue?vue&type=template&id=52907fdd&scoped=true&"
import script from "./add-merchants.vue?vue&type=script&lang=js&"
export * from "./add-merchants.vue?vue&type=script&lang=js&"
import style0 from "./add-merchants.vue?vue&type=style&index=0&id=52907fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52907fdd",
  null
  
)

export default component.exports